export var AuditTargetType;
(function (AuditTargetType) {
    AuditTargetType["ORGANIZATION"] = "organization";
    AuditTargetType["WORKSPACE"] = "workspace";
    AuditTargetType["USER"] = "user";
    AuditTargetType["INTEGRATION"] = "integration";
    AuditTargetType["CONNECTOR"] = "connector";
    AuditTargetType["MCP_CONNECTION"] = "mcp_connection";
    AuditTargetType["DOCUMENT"] = "document";
    AuditTargetType["INVITE"] = "invite";
    /** @deprecated Subscriptions were removed (LP-272); kept for historical audit rows. */
    AuditTargetType["SUBSCRIPTION"] = "subscription";
    AuditTargetType["PAYMENT"] = "payment";
    AuditTargetType["EXTERNAL_OBJECT"] = "external_object";
    AuditTargetType["AUDIT"] = "audit";
})(AuditTargetType || (AuditTargetType = {}));
//# sourceMappingURL=audit-target-type.enum.js.map